import { useMemo } from 'react';

/**
 * Where a [N] citation in a generated report leads.
 *
 * On a session the page owns the transcript and scrolls to the sentence. An
 * event has no transcript on screen, so the citation opens the session it came
 * from, which every reference records. Reports generated before cited sentences
 * were kept carry no references, and then a [N] stays plain text instead of
 * becoming a link that leads nowhere.
 */
export const useCitationHandler = (transcriptReferences, onCitationClick) => useMemo(() => {
  if (!transcriptReferences) return undefined;
  if (onCitationClick) return onCitationClick;
  return (startNum) => {
    const sessionId = transcriptReferences[String(startNum)]?.session_id;
    if (sessionId) window.open(`/sessions/${sessionId}`, '_blank', 'noopener,noreferrer');
  };
}, [transcriptReferences, onCitationClick]);
